import React from 'react';
import { Input, Button, PaperClip, Select } from 'components';
import { ServiceService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';
import { connect } from 'react-redux';

interface Props extends RootState {
	onClose?: any;
	item?: any;
	services: any;
}

class CreateService extends React.Component<Props> {

	state = {
		form: {
			service_id: '',
			description: '',
			amount: ''
		}
	}

	async componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					service_id: this.props.item?.service_id || '',
					description: this.props.item?.description || '',
					amount: this.props.item?.amount || '',
				},
				item: this.props.item
			});
		}
	}

	submit = async (e: any) => {
		e.preventDefault();
		if (this.props.item != null) {
			await ServiceService.clinic.edit({
				client_service_id: this.props.item?.id,
				...this.state.form,
			});
			Globals.showSuccess("Se ha modificado el servicio correctamente");
			this.props.onClose();
		}
		else {
			await ServiceService.clinic.create({
				...this.state.form,
				user_id: this.props.user?.id
			});
			Globals.showSuccess("Se ha creado el servicio correctamente");
			this.props.onClose();
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-clinic-create-service">
				<form onSubmit={ this.submit }>
					<div className="container-form">
						<h3>Nuevo Servicio</h3>
						<Select
							label="Tipo de Servicio (Consulta, Examen o Cirugía)"
							name="service_id"
							onChange={ this.change }
							value={ this.state.form.service_id }
							options={ this.props.services.map((i: any) => {
								return {
									value: i.id,
									label: i.name
								}
							}) } />
						<Input
							color="white"
							value={ this.state.form.description }
							name="description" 
							label="Descripción"
							onChange={ this.change } />
						<Input
							label="Precio"
							className="input-decimal"
							type="decimal-price"
							color="white"
							value={ this.state.form.amount ? ('$' + this.state.form.amount) : '' }
							name="amount" 
							placeholder="$0"
							onChange={ this.change } />
					</div>
					<div className="row row-buttons">
						<div className="col-md-6 text-center">
							<Button type="button" onClick={ () => this.props.onClose() }>
								Cerrar
							</Button>
						</div>
						<div className="col-md-6 text-center">
							<Button type="submit">
								Guardar
							</Button>
						</div>
					</div>
				</form>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(CreateService);